export default (user, { can, cannot, rules }) => {
  if (user.hasRole('yitBusinessAdmin')) {
    can("manage", "featuretoggle", {
      projectId: { $in: user.hcExtIds }
    });
  }
}